class LoginModal extends HTMLElement {
  constructor() {
    super();

    this.selectElements();
    this.attachListeners();

    if (JSON.parse(localStorage.getItem('login_remember'))) {
      this.rememberMe.checked = true
      this.form.elements['customer[email]'].value = localStorage.getItem('login_email')
      this.form.elements['customer[password]'].value = localStorage.getItem('login_password')
      this.form.elements['customer[email]'].dispatchEvent(new Event('change'))
      this.form.elements['customer[password]'].dispatchEvent(new Event('change'))
    }
  }

  selectElements() {
    this.form = this.querySelector("form#customer-login-form");
    this.rememberMe = this.querySelector("input#remember");
    this.loginBtn = this.querySelector("button#login-user");
  }

  // validate() {
  //   this.form.requestSubmit();
  // }

  async submit(e) {

    // if (!this.form.reportValidity()) {
    //   e.preventDefault();
    //   return
    // };

    if (this.rememberMe.checked) {
      localStorage.setItem('login_email', this.form.elements['customer[email]'].value)
      localStorage.setItem('login_password', this.form.elements['customer[password]'].value)
    } else {
      localStorage.removeItem('login_email')
      localStorage.removeItem('login_password')
    }
    localStorage.setItem('login_remember', this.rememberMe.checked)

    // this.form.submit();
  }

  attachListeners() {
    this.loginBtn.addEventListener("click", this.submit.bind(this));

    this.querySelectorAll("input.empty").forEach((el) =>
      el.addEventListener("change", (e) => {
        if (e.target.value) e.target.classList.remove("empty");
        else e.target.classList.add("empty");
      })
    );

    this.querySelectorAll("button[title='Toggle password visibility']").forEach(
      (el) =>
        el.addEventListener("click", (e) => {
          const input = el.parentNode.querySelector("input");
          if (input.type === "password") {
            input.type = "text";
            el.querySelector(".js-icon-visibility-off").classList.add("hidden")
            el.querySelector(".js-icon-visibility-on").classList.remove("hidden")
          } else if (input.type === "text") {
            input.type = "password";
            el.querySelector(".js-icon-visibility-off").classList.remove("hidden")
            el.querySelector(".js-icon-visibility-on").classList.add("hidden")
          }
        })
    );
  }

  // autoFillAndSubmit(email, password) {
  //   this.form.elements['customer[email]'].value = email;
  //   this.form.elements['customer[password]'].value = password;
  //   this.form.elements['customer[email]'].dispatchEvent(new Event('change'));
  //   this.form.elements['customer[password]'].dispatchEvent(new Event('change'));
  //   this.submit(new Event('submit'));
  // }
}

customElements.define("login-modal", LoginModal);
